<template>
    <div class="calendar-selection">
        <p class="calendar-selection__text">
            {{ $t('ProductDetails.productSelect.arrival') }}
            <span class="calendar-selection__date">{{ arrivalDate }}</span>
        </p>

        <button
            @click="backToCalendar"
            class="calendar-selection__back-button btn btn-icon ml-3"
            :title="$t('Generic.goback')"
        >
            <IconSvg filepath="crud/pencil-24px.svg" />
        </button>
    </div>
</template>

<script>
export default {
    name: 'CalendarSelection',

    props: {
        arrivalDate: {
            required: true,
            type: String
        }
    },

    methods: {
        backToCalendar() {
            this.$emit('back');
        }
    }
};
</script>

<style scoped lang="scss">
.calendar-selection {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    &__back-button {
        color: currentColor;
        line-height: 1em;
        font-size: 1.5em;

        &:hover {
            color: currentColor;
        }
    }

    &__text {
        font-style: italic;
        margin-bottom: 0;
    }

    &__date {
        font-style: normal;
        margin-left: 10px;
    }
}
</style>
